export const version = 'v1.60.E.20260507';
export const appClient = 'eicon';
export const appProduct = 'dte';
export const appOperation = 'build';
export const gerenciarSistemasRouterPath = '/configuracao/configurar-aplicacoes';
export const graphicCollors = {"axisColor":"#DADADA","baseColor":"#005baa","lineColor":"#005baa","fillColors":"#005baa","bulletColor":"#005baa"}; 
export const swallCollors = {"confirmButtonColor":"#005baa","cancelButtonColor":"#dc3545"};  
